/**
 * The six WMATA line colours. `MetroStripe` is the fixed band across the top
 * of every app; `MetroRule` is the same bands inline, under the wordmark on
 * sign-in style screens. Both are decoration and hidden from assistive tech.
 */

export function MetroStripe() {
  return <div className="metro-stripe" aria-hidden="true" data-print="hide" />;
}

export function MetroRule({ className = '' }: { className?: string }) {
  return <span className={`metro-rule ${className}`} aria-hidden="true" />;
}
